"use strict";
var obj;
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "parseUrl", {
    enumerable: !0,
    get: function() {
        return parseUrl;
    }
});
const _urlparse = (obj = require("url-parse")) && obj.__esModule ? obj : {
    default: obj
};
function parseUrl(source) {
    return new _urlparse.default(source, !0);
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL1VybC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFBhcnNlZFVybFF1ZXJ5IH0gZnJvbSAncXVlcnlzdHJpbmcnXG5pbXBvcnQgVVJMUGFyc2UgZnJvbSAndXJsLXBhcnNlJ1xuXG4vKipcbiAqIFBhcnNlcyB0aGUgVVJMIHRvIGFuIG9iamVjdC4gV29ya3MgaW4gYWxsIGVudmlyb25tZW50cywgYXMgb3Bwb3NlZCB0byB3ZWIgVVJMIGFwaS5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHBhcnNlVXJsKHNvdXJjZTogc3RyaW5nKTogVVJMUGFyc2U8UGFyc2VkVXJsUXVlcnk+IHtcbiAgICByZXR1cm4gbmV3IFVSTFBhcnNlKHNvdXJjZSwgdHJ1ZSlcbn1cbiJdLCJuYW1lcyI6WyJwYXJzZVVybCIsInNvdXJjZSIsIlVSTFBhcnNlIl0sIm1hcHBpbmdzIjoiOzs7O21DQU1nQkE7OztlQUFBQTs7O2lDQUxLOzs7QUFLZCxTQUFTQSxTQUFTQyxNQUFjO0lBQ25DLE9BQU8sSUFBSUMsaUJBQVEsQ0FBQ0QsUUFBUSxDQUFBO0FBQ2hDIn0=